import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import styles from './styles.scss';

const SearchBoxComponent = ({value, onValueChange, onKeyUp, onApply, iconClass, searchPh}) => {
  return (
	  <div styleName="searchbox-wrapper">
		<input
			placeholder={searchPh}
			type="text"
			value={value}
			onChange={onValueChange}
			onKeyUp={onKeyUp}
		/>
		<span
			styleName="iconSearch"
			className={iconClass}
			onClick={onApply}
		>

		</span>
	  </div>
  );
};

SearchBoxComponent.propTypes = {
  value: PropTypes.string.isRequired,
  onValueChange: PropTypes.func.isRequired,
  onKeyUp: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  iconClass: PropTypes.string.isRequired
};

SearchBoxComponent.defaultProps = {
  value: '',
  onValueChange: () => {
  },
  onKeyUp: () => {
  },
  onApply: () => {
  },
  iconClass: 'fa fa-search',
  searchPh: '',
};

export default CSSModules(SearchBoxComponent, {...styles}, {allowMultiple: true});


// WEBPACK FOOTER //
// ./components/qual/Table/TableHeader/TableHeaderCell/TableColumnFilter/FilterTypes/MultipleChoice/SearchBox/Searchbox_component.js